import { SetStakeModalPage, SFXS } from "@orbital/games-frontend-library"
import React from "react"
import { SetStakeWrapper } from "./SetStakeStyles"

export default function SetStake({
  gameInfo,
  currentStake,
  handleStake,
  handleNotification,
  audio,
  handleModal,
  balance,
  modalAnim
}: any) {
  const colors = {
    primaryDark: "#261746",
    primaryLight: "#261746",
    secondary: "#ffb000",
    tertiary: "#171731",
    secondaryDark: "#D29809",
    tertiaryDark: "#171731",
  }
  return (
    <SetStakeWrapper anim={modalAnim}>
      <SetStakeModalPage
        gameInfo={gameInfo}
        colors={colors}
        balance={balance}
        stake={currentStake}
        handleStake={handleStake}
        handleNotification={handleNotification}
        audio={audio}
        isZero={false}
        SFX={SFXS}
        handleModal={handleModal}
        hasTenX={true}
        IsInline={true}
      />
    </SetStakeWrapper>
  )
}
